import { singleton } from 'tsyringe';
import type { AnalyticsSurface } from './AnalyticsSurface';

/**
 * Registry of surface definitions, keyed by surface id. Populated once at
 * startup by the composition root — features contribute their surface
 * definitions via {@link register}, keeping the shared engine feature-blind.
 */
@singleton()
export class SurfaceRegistry {
    private readonly surfaces = new Map<string, AnalyticsSurface>();

    register(defs: AnalyticsSurface[]): void {
        for (const def of defs) this.surfaces.set(def.id, def);
    }

    find(id: string | undefined): AnalyticsSurface | undefined {
        return id === undefined ? undefined : this.surfaces.get(id);
    }
}
